import * as React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import Navigation from '@/components/Navigation';
import HeroSection from '@/components/HeroSection';
import MarqueeBanner from '@/components/MarqueeBanner';
import StorySection from '@/components/StorySection';
import Programs from '@/components/Programs';
import Testimonials from '@/components/Testimonials';
import Gallery from '@/components/Gallery';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import ContactFloatingButton from '@/components/ContactFloatingButton';

const Index: React.FC = () => {
  /* Smooth-scroll to hash on load / popstate */
  React.useEffect(() => {
    const scrollToHash = () => {
      if (window.location.hash) {
        const el = document.querySelector(window.location.hash);
        if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 120);
      }
    };
    scrollToHash();
    window.addEventListener('popstate', scrollToHash);
    return () => window.removeEventListener('popstate', scrollToHash);
  }, []);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        className="min-h-screen flex flex-col"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.5, ease: 'easeInOut' } }}
        exit={{ opacity: 0, transition: { duration: 0.3, ease: 'easeInOut' } }}
      >
        <Navigation />

        <main className="flex-grow">
          {/* 1. Full-screen cinematic hero with parallax */}
          <HeroSection />

          {/* 2. Enrollment announcement ticker */}
          <MarqueeBanner />

          {/* 3. Scroll-pinned story section (3 acts, 300vh tall) */}
          <StorySection />

          {/* 4. Programs grid — staggered on scroll */}
          <Programs />

          {/* 5. Parent testimonials — parallax dark section */}
          <Testimonials />

          {/* 6. Campus life gallery — bento grid with lightbox */}
          <Gallery />

          {/* 7. Contact form + map */}
          <Contact />
        </main>

        <Footer />

        {/* Floating contact button */}
        <ContactFloatingButton />
      </motion.div>
    </AnimatePresence>
  );
};

export default Index;
